import { OrgCouponId, OrgRegistrationPackageId, OrgId } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";
import { firestoreLiftDocSubToBifrostSub } from "../../internal-utils/firestoreLiftSubToBifrostSub";

export function orgRegistrationPackage__client__getOrgRegistrationPackageSubscription(p: { id: OrgRegistrationPackageId }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();

  return firestoreLiftDocSubToBifrostSub(h.OrgRegistrationPackage.docSubscription(p.id));
}
